import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// import Grid from '@mui/material/Grid';
// import ProductIcon from '@mui/icons-material/Inventory2Outlined';

import { ProductsTableContainer } from '../../components/products';
// import StatsBox from '../../components/shared/StatsBox';

import { fetchDistributors } from '../../actions/adminActions';
import { fetchProductTags } from '../../actions/productsActions';

import './admin.scss';

const ProductsPage = ({ products, distributors, fetchDistributors, fetchProductTags }) => {
  useEffect(() => {
    fetchDistributors();
    fetchProductTags();
  }, [fetchDistributors, fetchProductTags]);

  return (
    <div className="admin-page">
      {/*<Grid container spacing={3} sx={{ mb: 3 }}>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Products' number={products?.length} icon={<ProductIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Products' number={products?.length} icon={<ProductIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Products' number={products?.length} icon={<ProductIcon />} />*/}
      {/*  </Grid>*/}
      {/*</Grid>*/}
      <ProductsTableContainer
        products={products}
        distributors={distributors}
        withButton
      />
    </div>
  );
};

ProductsPage.propTypes = {
  products: PropTypes.array,
  distributors: PropTypes.array,
  fetchDistributors: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  products: state.products.list,
  distributors: state.distributors.list,
});

const mapDispatchToProps = (dispatch) => ({
  fetchDistributors: () => dispatch(fetchDistributors()),
  fetchProductTags: () => dispatch(fetchProductTags()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductsPage);
